import { createI18n } from 'vue-i18n'
import zh from './locales/zh-CN.json'
import en from './locales/en-US.json'
import legalEn from './locales/legal-content-en.json'
import legalZh from './locales/legal-content-zh.json'

// 1. 定义获取浏览器默认语言的函数
const getBrowserLanguage = () => {
  const language = navigator.language || navigator.userLanguage

  if (language.toLocaleLowerCase().includes('zh')) {
    return 'zh-CN'
  }

  return 'en-US'
}

const i18n = createI18n({
  legacy: false, // 使用 Composition API 模式，必须设置为 false
  // Options API / 模板里用 this.$t 时必须开启（如 loading.vue、tab.vue）
  globalInjection: true,
  locale: 'en-US', // 初始化默认语言
  fallbackLocale: 'en-US', // 找不到当前语言键值时的回退语言
  messages: {
    'en-US': {
      ...en,
      legal: { ...(en.legal || {}), ...legalEn }
    },
    'zh-CN': {
      ...zh,
      legal: { ...(zh.legal || {}), ...legalZh }
    }
  }
})

export default i18n
